"use strict";

import warnAboutDeprecatedESMImport from "./warnAboutDeprecatedESMImport.js";
warnAboutDeprecatedESMImport("Link");

import { Link } from "../esm/react-router-dom.js";
export default Link;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/Link.js
// module id = 627
// module chunks = 0